import { render, staticRenderFns } from "./donutChart.vue?vue&type=template&id=96d01528&scoped=true"
import script from "./donutChart.vue?vue&type=script&lang=js"
export * from "./donutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d01528",
  null
  
)

export default component.exports